import { Link } from 'react-router-dom';
import { useSite } from '../hooks/useSite';
import { PAGE, pick } from '../lib/content';
import { imageUrl } from '../lib/images';

export default function Footer() {
  const { navigation, settings, pathFor } = useSite();
  const items = navigation.filter((item) => item.terms?.['navigation-area']?.includes('hovedmenu') && !item.parent_key).sort((a, b) => a.sort_order - b.sort_order);
  const home = pathFor(PAGE.home) || '/';
  const logo = settings?.logo?.[0] || 'https://assets.auxodev.dk/assets/4b113068-ba57-4700-bbd1-eaf8ad18c2aa/christinas-logo.jpg';
  return <footer className="border-t border-ink/10 bg-[#fffffe] text-ink">
    <div className="mx-auto grid max-w-[1600px] gap-x-12 gap-y-12 px-5 pt-20 pb-14 sm:px-8 lg:grid-cols-[1.15fr_.7fr_1fr] lg:px-12 lg:pt-24 2xl:px-16">
      <div>
        <Link to={home} aria-label="Salon K9 – til forsiden" className="inline-block max-w-full focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal">
          <img src={imageUrl(logo, 'width=600,quality=85,format=auto')} alt="Christinas Hundeklip – Salon K9" loading="lazy" className="w-[130px] sm:w-[160px] lg:w-[230px]" />
        </Link>
      </div>
      <div>
        <h2 className="text-xs font-extrabold uppercase tracking-[.2em] text-teal-dark">Udforsk</h2>
        <nav aria-label="Footer navigation" className="mt-6 flex flex-col items-start gap-3">
          {items.map((item) => (
            <Link
              key={item.id}
              to={item.href}
              className="min-h-9 py-1 text-sm font-semibold text-body transition-colors hover:text-ink hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal"
            >
              {pick(item.label)}
            </Link>
          ))}
        </nav>
      </div>
      <div>
        <h2 className="text-xs font-extrabold uppercase tracking-[.2em] text-teal-dark">Find os</h2>
        <address className="mt-6 space-y-4 text-sm leading-7 not-italic text-body">
          <p>{settings?.address_line}<br />{settings?.postal_city}</p>
          <p className="flex flex-col items-start gap-1">
            <a href={`tel:${String(settings?.phone || '').replace(/\s/g, '')}`} className="whitespace-nowrap hover:text-ink hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal">
              Telefon: {settings?.phone}
            </a>
            <a href={`mailto:${settings?.email || ''}`} className="whitespace-nowrap text-[clamp(0.75rem,2.7vw,0.875rem)] hover:text-ink hover:underline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal">
              E-mail: {settings?.email}
            </a>
          </p>
          <p>CVR: {settings?.cvr}</p>
        </address>
        {settings?.facebook_url && (
          <a
            href={settings.facebook_url}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Salon K9 på Facebook (åbner i ny fane)"
            className="mt-8 inline-flex min-h-12 items-center gap-3 border-b border-ink/30 text-sm font-bold text-ink transition-colors hover:border-teal hover:text-teal focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-teal"
          >
            <i className="fa-brands fa-facebook-f text-lg" aria-hidden="true" /> Følg os på Facebook <i className="fa-regular fa-arrow-up-right text-xs" aria-hidden="true" />
          </a>
        )}
      </div>
    </div>
    <div className="border-t border-ink/10">
      <div className="mx-auto flex max-w-[1600px] flex-wrap justify-between gap-3 px-5 py-6 text-xs text-body sm:px-8 lg:px-12 2xl:px-16">
        <span>© {new Date().getFullYear()} Salon K9 v/Christina Blom</span>
        <span>Hundefrisøruddannelse · Pelspleje · Behandling</span>
      </div>
    </div>
  </footer>;
}
